export const getUserInitials = (name) => {
	if (!name) return '?';

	return name
		.split(' ')
		.slice(0, 2)
		.map((p) => p[0])
		.join('')
		.toUpperCase();
};
